// extend lity.js to support YouTube playlist URLs
/*!
 * Lity YouTube handler
 * Extends Lity (https://github.com/jsor/lity) with a handler that uses the
 * real YouTube IFrame Player API instead of a bare <iframe>, so playlists
 * work properly and playback stops the instant the lightbox closes.
 *
 * Load this AFTER lity.js. No changes to lity.js itself are needed —
 * this only uses Lity's public handler-registration API (`lity.handlers`)
 * and the `lity:ready` / `lity:close` / `lity:remove` events it already
 * fires on the content element.
 */
(function ($) {
	'use strict';

	if (!$ || !window.lity) {
		return;
	}

	// -- Load the YouTube IFrame API once, lazily, the first time it's needed --
	var apiReady = $.Deferred();
	var apiRequested = false;

	function loadYouTubeApi() {
		if (apiRequested) {
			return;
		}
		apiRequested = true;

		if (window.YT && window.YT.Player) {
			apiReady.resolve();
			return;
		}

		var previousCallback = window.onYouTubeIframeAPIReady;
		window.onYouTubeIframeAPIReady = function () {
			if (typeof previousCallback === 'function') {
				previousCallback();
			}
			apiReady.resolve();
		};

		var tag = document.createElement('script');
		tag.src = 'https://www.youtube.com/iframe_api';
		document.head.appendChild(tag);
	}

	// -- Pull a video id and/or playlist id out of any common YouTube URL shape --
	function parseYouTubeUrl(url) {
		var videoMatch = url.match(
			/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/
		);
		var listMatch = url.match(/[?&]list=([\w-]+)/);

		return {
			videoId: videoMatch ? videoMatch[1] : null,
			listId: listMatch ? listMatch[1] : null
		};
	}

	var playerSeq = 0;

	function youtubeApiHandler(target, instance) {
		instance && instance.element().addClass('lity-iframe lity-youtube');

		var parsed = parseYouTubeUrl(target);
		var deferred = $.Deferred();
		var containerId = 'lity-yt-' + (++playerSeq);

		var $container = $(
			'<div class="lity-iframe-container lity-youtube-container">' +
				'<div id="' + containerId + '"></div>' +
			'</div>'
		);

		loadYouTubeApi();

		deferred.resolve($container);

		$container.one('lity:ready', function () {
			apiReady.done(function () {
				var playerVars = {
					autoplay: 1,
					playsinline: 1,
					rel: 0
				};
				var playerOptions = {
					height: '100%',
					width: '100%',
					playerVars: playerVars
				};

				if (parsed.listId) {
					playerVars.listType = 'playlist';
					playerVars.list = parsed.listId;
					if (parsed.videoId) {
						playerOptions.videoId = parsed.videoId;
					}
				} else if (parsed.videoId) {
					playerOptions.videoId = parsed.videoId;
				} else {
					return;
				}

				var player = new YT.Player(containerId, playerOptions);
				$container.data('lity-yt-player', player);
			});
		});

		$container.one('lity:close', function () {
			var player = $container.data('lity-yt-player');
			if (player && typeof player.pauseVideo === 'function') {
				player.pauseVideo();
			}
		});

		$container.one('lity:remove', function () {
			var player = $container.data('lity-yt-player');
			if (player && typeof player.destroy === 'function') {
				player.destroy();
			}
		});

		return deferred.promise();
	}

	youtubeApiHandler.test = function (target) {
		return /(?:youtube\.com|youtu\.be)/i.test(target);
	};

	window.lity.handlers({ youtube: youtubeApiHandler });
}(window.jQuery));